import React, { Fragment, useEffect, useState } from "react";

import { Button, Img, Line, List, Text } from "components";
import ContextMenu from "components/ContextMenu";
import Header from "components/Header";
import InfoRibbon from "components/InfoRibbon";
import Star from "components/Star";
import { useLocation, useNavigate } from "react-router-dom";
import { formatCurrency } from "../../helpers/number";
import { addToCart } from "../../states/cart.mjs";
import Footer1 from "../../components/Footer1";
import { parseImageDescriptionToHTML } from "../../helpers/string.mjs";
import { clearSearchKeyword } from "../../states/search.mjs";

const ProductDetailPagePage = () => {
  const [selected, setSelected] = useState(undefined);
  const [selectedImage, setSelectedImage] = useState(undefined);
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedImage(selected?.images[0]);
  }, [selected]);

  useEffect(() => {
    setSelected(state);
  }, [state]);

  useEffect(() => {
    return () => {
      clearSearchKeyword();
    };
  }, []);

  return (
    <>
      <div className="bg-white-A700 flex flex-col font-inter items-start justify-start mx-auto w-full">
        <InfoRibbon className="bg-deep_purple-900 flex flex-row md:gap-10 items-center justify-between p-3 w-full" />
        <Header showSearch={false} />
        <ContextMenu />
        {
          selected && <>
            <div className="flex flex-col items-center w-full">
              <div className="flex md:flex-col flex-row gap-2 items-start justify-center mt-[68px] px-8  w-full">
                <div
                  className="flex md:flex-row flex-col gap-[16px] md:overflow-scroll md:static sticky top-[130px] items-center justify-start">
                  {
                    selected?.images?.map((image, index) => {
                      return (
                        <Fragment key={`${image}${index}`}>
                          <div onClick={() => {
                            setSelectedImage(() => image);
                          }} className="flex justify-center items-center border rounded-lg min-w-[100px]">
                            <Img
                              className="h-[84px] cursor-pointer object-contain rounded-lg w-[84px]"
                              src={image}
                              alt="rectangleTwentyFive"
                            />
                          </div>
                        </Fragment>
                      );
                    })
                  }
                </div>
                {
                  [selectedImage].map((x, index) => {
                    return (
                      <Fragment key={`${x}${index}`}>
                        <div className="w-full">
                          <Img
                            className="md:h-[400px] w-full h-[629px] flex-1 border bg-white-A700 object-contain rounded-lg"
                            src={selectedImage}
                            alt="rectangleThirtyOne"
                          />
                        </div>
                      </Fragment>
                    );
                  })
                }
                {/*<div className="flex flex-col items-center justify-start md:max-w-[0] md-w-full max-w-[400px] md:static sticky top-[100px] p-[11px] rounded-lg">*/}
                <div
                  className="flex flex-col md:w-full md:max-w-full max-w-[400px] md:static sticky top-[100px] gap-3 items-center justify-start mb-[25px] mt-[11px] w-full">
                  <div className="flex flex-col items-start justify-start w-full">
                    <Text
                      className="leading-[24.00px] text-black-900_dd text-xl tracking-[0.15px]"
                      size="txtInterRegular20"
                    >
                      <>
                        {selected?.product}
                      </>
                    </Text>
                    <List
                      className="sm:flex-col flex-row gap-2 grid grid-cols-5 mt-[8px]"
                      orientation="horizontal"
                    >
                      <Star className="flex flex-col items-center justify-start w-full" />
                      <Star className="flex flex-col items-center justify-start w-full" />
                      <Star className="flex flex-col items-center justify-start w-full" />
                      <Star className="flex flex-col items-center justify-start w-full" />
                      <div className="flex flex-col items-center justify-start w-full">
                        <Img
                          className="h-[27px] w-7"
                          src="images/img_star9.svg"
                          alt="starNine"
                        />
                      </div>
                    </List>
                    <div className="flex flex-col items-start justify-start mt-[15px] w-[59%] md:w-full">
                      <div className="flex flex-row gap-3 items-start justify-start">
                        <Text
                          className="text-blue_gray-700 text-xs tracking-[0.40px]"
                          size="txtInterRegular12"
                        >
                          TZS
                        </Text>
                        <Text
                          className="text-black-900_dd text-xl tracking-[0.15px]"
                          size="txtInterMedium20"
                        >
                          {formatCurrency(selected?.retailPrice)}
                        </Text>
                      </div>
                      <Text
                        className="flex mt-[8px] text-black-900_99 text-xs tracking-[0.25px]"
                        size="txtInterRegular12Black90099"
                      >
                        Only few remains in stock order now
                      </Text>
                    </div>
                    <div className="flex flex-col font-urbanist items-start justify-start mt-[18px] pb-[26px] w-full">
                      <Text
                        className="leading-[19.00px] text-black-900_dd text-sm tracking-[0.20px]"
                        size="txtUrbanistRegular14"
                      >
                          <span
                            className="text-black-900_dd tracking-[0.15px] font-roboto text-left text-base font-normal">
                            <span dangerouslySetInnerHTML={{
                              __html: parseImageDescriptionToHTML(((selected?.description?.split('--')?.[1])??(selected?.description?.split('--')?.[0]))?.replaceAll('-','')?.trim())
                            }} />
                          </span>
                      </Text>
                    </div>
                  </div>
                  <div className="flex flex-col justify-start items-start w-full">
                    <Button
                      onClick={() => {
                        addToCart(selected, 1);
                        navigate("/cartreviewpage");
                      }}
                      className="!bg-colors3 !rounded-[37px] cursor-pointer flex h-12 items-center justify-center min-w-[300px] mt-[11px]"
                      leftIcon={
                        <Img
                          className="mr-[19px]"
                          src="images/img_payment.svg"
                          alt="Payment"
                        />
                      }
                      shape="circle"
                      color="orange_A200"
                      size="xs"
                      variant="fill"
                    >
                      <div className="text-base text-left tracking-[0.25px]">
                        Buy now
                      </div>
                    </Button>
                    {/*<div className="flex flex-col items-center justify-start mt-[31px] w-[99%] md:w-full">*/}
                    <Button
                      onClick={() => {
                        addToCart(selected, 1);
                        navigate("/cartreviewpage");
                        // addToCart(selected, 1);
                        // toast.success(`${selected?.product} added to cart`);
                      }}
                      className="!bg-colors4 !rounded-[37px] mt-[16px] cursor-pointer flex h-12 items-center justify-center min-w-[300px]"
                      leftIcon={
                        <Img
                          className="mr-[13px]"
                          src="images/img_shopping_cart_white_a700.svg"
                          alt="Shopping cart"
                        />
                      }
                      shape="circle"
                      color="indigo_A700"
                      size="xs"
                      variant="fill"
                    >
                      <div className="!text-white-A700 text-base text-left tracking-[0.25px]">
                        Add to cart
                      </div>
                    </Button>
                  </div>
                  {/*</div>*/}
                </div>
                {/*</div>*/}
              </div>
              <Line className="bg-gray-300 h-px mt-[24px] my-[24px] mx-auto w-full" />
            </div>
            {/*<Text*/}
            {/*  className="px-[24px] pt-[24px] text-2xl md:text-[22px] text-center text-gray-900_02 sm:text-xl tracking-[0.18px]"*/}
            {/*  size="txtInterRegular24"*/}
            {/*>*/}
            {/*  Other products*/}
            {/*</Text>*/}
          </>
        }
        {/*<MoreProducts*/}
        {/*  onAddToBasket={(element) => {*/}
        {/*    // addToCart(element, 1);*/}
        {/*    // toast.success(`${element?.product} added to cart`);*/}
        {/*    setSelected({ ...element ?? {} });*/}
        {/*    // navigate("/productdetailpage", {*/}
        {/*    //   state: { ...element ?? {} }*/}
        {/*    // });*/}
        {/*    scrollToTop();*/}
        {/*  }}*/}
        {/*  onSelect={(element) => {*/}
        {/*    setSelected({ ...element ?? {} });*/}
        {/*    // navigate("/productdetailpage", {*/}
        {/*    //   state: { ...element ?? {} }*/}
        {/*    // });*/}
        {/*    scrollToTop();*/}
        {/*  }}*/}
        {/*/>*/}
        <Footer1 className="bg-blue_gray-900 mt-16 flex flex-col items-center justify-start p-6 sm:px-5 w-full" />
      </div>
    </>
  );
};

export default ProductDetailPagePage;
